import { render, staticRenderFns } from "./ModalInformacoesGenitor.vue?vue&type=template&id=2fc4d456&"
import script from "./ModalInformacoesGenitor.vue?vue&type=script&lang=js&"
export * from "./ModalInformacoesGenitor.vue?vue&type=script&lang=js&"
import style0 from "./ModalInformacoesGenitor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports